import { Box, Typography } from "@mui/material";

export default function GeneralError() {
  return (
    <Box textAlign="center" height="300px">
      <Typography fontSize={70} lineHeight="normal" sx={{ px: 7, py: 5 }}>
        ГРЕШКА
      </Typography>
      <Typography>Възникна непредвидена грешка. Моля, опитайте по-късно.</Typography>
    </Box>
  );
}
